/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import SectionFive from "../components/page-sections/downloadpage/SectionFive";

const Download = () => {
  return (
    <React.Fragment>
      <Layout>
        <SectionFive />
      </Layout>
    </React.Fragment>
  );
};

export default Download;
